import {Component, OnDestroy, OnInit, Input, HostListener} from '@angular/core';
import {MatSnackBar, MatDialog, MatCheckboxChange} from '@angular/material';
import {ActivatedRoute, Router} from '@angular/router';
import {MapComponent} from '../../map.component'
import {Annotation} from '4d-mapper'
import {MapService} from '../../../../commons/map.service';

import {AppConstants, APITypes, AnnotationType} from '../../../../commons/global';
import {BaseAnnotViewer} from './base_annot.component';
import {BaseMeasure} from './base_measure.component';
import {MeasurementHelperService} from '../../../../service/measurement-helper.service';
import {EntityHelperService} from '../../../../service/entity-helper.service';
import {Constants} from '../../../../commons/Constants';
import { XsApplicationEventsService } from '../../../../xs/services/events/application-events.service';
import { EpsgHelperService } from '../../../../service/epsg-helper.service';
import { CoordHelperService } from '@src/app/service/coord-helper.service';
import { XsAwait } from '@src/app/xs/controllers/await.class';
import { resolve } from 'url';

const Cesium = (<any>window).Cesium
import * as _ from 'lodash';
import { FileManagementService } from '@src/app/service/file-manager.service';

@Component({
  selector: 'line-comp',
  templateUrl: './line.component.html'
})
export class LineViewer extends BaseMeasure implements OnInit, OnDestroy {

  debug:boolean = Constants.debug_off;

  hasProfiler:boolean = true;
  showProfileOptions:boolean = false;
  toggleShowProfileOptions() {
    this.showProfileOptions = !this.showProfileOptions;
  }

  profile:any = null;

  samplingRate:number = null;

  sampleMethod:string = "terrain";
  sampleOn:any = null;
  sampleResolution:string = 'high';

  showChart:boolean = false;
  chartData:any = null;

  chart:any = {

    legend: false,
    // view: [containerRef.offsetWidth, containerRef.offsetHeight],

    // options
    showLabels: true,
    animations: true,
    xAxis: true,
    yAxis: true,
    showYAxisLabel: true,
    showXAxisLabel: true,
    xAxisLabel: 'Line length',
    yAxisLabel: 'Height',
    xScaleMin:0, xScaleMax:0,
    yScaleMin:0, yScaleMax:0,
    timeline: false,

    colorScheme: {
      domain: ['#5A84A4', '#5A94b4', '#5A84A4', '#5A94b4', '#5A84A4', '#5A94b4','#5A84A4', '#5A94b4', '#5A84A4', '#5A94b4', '#5A84A4', '#5A94b4' ]
    },

    data: []
  };

  // the points from a line we're analyzing on
  points:any[] = [];

  cursor:any = null;

  constructor(protected route: ActivatedRoute, public router: Router, snackBar:
    MatSnackBar, dialog: MatDialog, public mapComp: MapComponent, public mapService: MapService, public mappingHelper: MeasurementHelperService, 
    public entityHelper: EntityHelperService, public applicationEvents:XsApplicationEventsService, public epsgHelper: EpsgHelperService, public fileManager: FileManagementService,
    public coordHelper: CoordHelperService ) {
    super(route, router, snackBar, dialog, mapComp, mapService, mappingHelper, entityHelper, applicationEvents, epsgHelper, fileManager );
    
    // this.clampToModel = false;
    // this.selectedShapes = new Map();
    // console.log ( 'line.component CONSTRUCTOR', this);
  }

  init() {
    // console.log ('@@@');
    super.onInit();

    if ( this.debug ) { console.log ( this.debugMe2 + ' LINE onInit() awaiting ...', Constants._blue, Constants._orange );  }
    
  }
  onAnnotationReady(){
    super.onAnnotationReady();

    if ( this.annotation['clickedOnType'] ) {
      console.log('### auto type', this.annotation['clickedOnType'] );
      this.sampleMethod = this.annotation['clickedOnType'];
    }

    if ( this.annotation['clickedOnId'] ) {
      let find = this.mapService.sceneTransforms.find( f => f.id == this.annotation['clickedOnId'] );
      if ( find ) {
        this.sampleOn = this.mapService.helper.getCesiumObjectFor(find);
        console.log('### auto id', this.annotation['clickedOnId'], find, this.sampleOn );
      }
    }
    
    this.calculateProfiler();
  }

  @HostListener('unloaded')
  ngOnDestroy() {
    if ( this.debug ) { console.log ( 'line.comp :: ngOnDestroy()'); }
    this.closeProfiler();
    try {
      super.onDestroy();
      // this.removeRuntimeLine();
      // this.removeLineInfoEntities();
    } catch (e) {
      console.log(e.message);
    }
  }

  closeProfiler() {
    // if ( this.profile ) {
    //   this.profile.samplingCompleted = false;
    // }
    this.showChart = false;
    if ( this.interval ) {
      clearInterval( this.interval );
      this.interval = null;
    }
    this.chartCursorValue = null;
    if ( this.cursor ) {
      this.mapService.viewer.entities.remove(this.cursor);
      this.cursor = null;
    }
  }

  interval:any = null;
  chartCursorValue:any = null;

  openProfiler() {

    this.showChart = true;
    // this.profile.samplingCompleted = true;

    if ( !this.cursor ) {
      this.cursor = this.mapService.viewer.entities.add ({
        show:true,
        billboard : {
            image : 'assets/images/icons/gcp-green.png',
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
            //heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
            //disableDepthTestDistance: Number.POSITIVE_INFINITY,
            scale:0.4
        }
    });
    }

    if ( !this.interval ) {

      setInterval ( () => {

        // let el = document.getElementById('profileGraph');
        // if ( el ) {
          let test = null;
          let c3 = document.querySelector('#profileGraph .innerGraph g[ngx-charts-circle-series]');
          if ( c3 ) {
            this.chartCursorValue = c3.getAttribute('ng-reflect-visible-value');

            test = this.LUT[this.chartCursorValue];
            if ( test && this.cursor ) {
              this.cursor.position = test.accurateCoord; //  ? test.accurateCoord : test.coord;
              // console.log('#',test);
            }
            // 
          }
          // console.log('@@@@@@', c3, test, this.chartCursorValue, this.cursor );
        // } else {
        //   this.chartCursorValue = null;
        // }

      }, 300 );

    }

  }

  annotationUpdated(){
    this.calculateProfiler();
  }

  calculateProfiler( $event = null ) {

      XsAwait.until( 'coordHelper', this ).then ( _ => {
        
      const shape = this.shapes[this.shapeMaker.selectedShape];

      // sr = this.samplingRate;
      if ( $event && $event.value ) {
        this.samplingRate = $event.value;
      }
      if ( shape && shape.points && shape.points.length ) {
        let points = shape.points.map(p => p.coords);
        if ( points && points.length && points.length > 1 ) {
          this.points = points;
          this.profile = this.coordHelper.heightProfileAnalysis ( this.points, { samplingRate:this.samplingRate });
          // this.profile.samplingRate.max = 40;
          // console.log( 'PROFILER CALC', $event, this.profile );
          this.samplingRate = this.profile.samplingRate.value;
        }
      }

    });
  }

  startProfiler() {
    this.calculating = true;
    this.totalCalc = 1;
    this.profile = this.coordHelper.heightProfileAnalysis ( _.cloneDeep(this.points), { samplingRate:this.samplingRate });
    const me = this;
    setTimeout ( () => { me.startProfilerLaunch(); }, 200 );
  }

  LUT:any = null;
  LUT_line:any = null;

  startProfilerLaunch() {

    console.log( 'PROFILER START', this.profile, this );

    this.calculating = true;
    this.chart.data = [];

    let idx = 0;
    this.LUT_line = {};

    this.profile.samplingPointsLine.forEach ( line => {
      line.items.forEach ( item => {
        this.LUT_line[idx] = line.idx;
        idx++;
      });
    });

    const p = this.sampleProfiler ( this.profile ).then( final => {

      this.profile = final;
      
      let data = [];
      this.LUT = {};

      idx = 0;

      final.samplingPointsLine.forEach ( line => {

        let items = [];
        line.items.forEach ( item => {
          let pos = final.renderPoints[idx];
          let key = final.arrXAxis[idx];
          let height = final.arrYAxis[idx];
          let extra = { key:key, value:final.arrYAxis[idx], coord:item, accurateCoord:pos, idx:idx, lineIdx:line.idx };
          this.LUT[key] = extra;

          // hack: if sampled item is less than 0.5, it's probably hitting the globe, and we'll assume (for now) that
          // that's a miss (especially on pointclouds)

          if ( height > 0.5 ) {
          items.push({ name: key, value: final.arrYAxis[idx], extra:extra  });
          }
          idx++;
        });

        data.push({ name: 'Line '+(line.idx) + ' ('+Math.floor(line.dist)+'m) ', value:'test', series: items });

      });

      // this.chart.data = data;
      this.chartData = data;

      this.openProfiler();

      console.log( 'PROFILER CHART', this.profile, data );

      this.calculating = false;
    });
  }



  sampleProfiler( profile:any ) : any {

    const me = this;

    // new annotation will be id=0
    let id = this.annotation.id ? this.annotation.id : 0;

    let entities = this.entityHelper.getEntitiesByAnnotationId(id).map( e => e.obj );

    // console.log ( '%c PROFILER %c OBJECTS', this.debugPrimary, Constants._red, id, entities );

    return new Promise(resolve => {

      const promise = this.sampleInChunks ( profile.coords, entities ).then ( result => {

        // console.log ( '%c PROFILER %c PROMISE WHEN', me.debugPrimary, Constants._red, this.sampleMethod, profile.coords.length, result );
          var min = 9000;
          var max = -12000;
          
          for (var kk = 0; kk < result.length; kk++) {
            
              var position = result[kk];
              var cartesian = me.mapService.viewer.scene.globe.ellipsoid.cartographicToCartesian(position);
              if ( position.height < 1 ) {
                console.log('## sample', kk, position, cartesian);
                // cartesian = 0;
              } // else {
                profile.renderPoints.push(cartesian);
                var tempCarto = Cesium.Cartographic.fromCartesian(cartesian);
                profile.arrYAxis.push(parseFloat(tempCarto.height.toFixed(4))); // prepare Y axis
                // Get the maximum and minimum elevation
                if (tempCarto.height < min) {
                    min = tempCarto.height;
                }
                if (tempCarto.height > max) {
                    max = tempCarto.height;
                }
              // }  
          }

          profile.minElevation = min;
          profile.maxElevation = max;
  
          this.chart.yScaleMin = min;
          this.chart.yScaleMax = max;
          this.chart.xScaleMin = 0;
          this.chart.xScaleMax = profile.totalDistance;
  
          this.entityHelper.destroyEntitiesByCaller ( 'volume_calc' );
          
          // profile.samplingCompleted = true;
  
          // console.log ( '%c LAYERS %c analysis() DONE', me.debugPrimary, Constants._red, profile );
  
          resolve(profile);
  
      });
      
    });
  }

  sampleInChunks ( positions:any[] = [], objectsToExclude:any[] = [], chunkSize:number = 10 ) : any {

    // our progress object
    let progress = {
      chunkIndex: 0,
      promises: Math.ceil ( positions.length / chunkSize ) - 1,
      done: 0, 
      factor: 100 / positions.length
    }

    // console.log ( '%c PROFILER %c SAMPLE_IN_CHUNKS', this.debugPrimary, Constants._red, progress );

    // determined calculation bar
    this.totalCalc = 0;
    this.percentFinished = 0;

    // let's make a promise ...
    let thisPromise = new Promise( resolve => {
      this.samplePromiseRecursive ( positions, objectsToExclude, chunkSize, resolve, progress );
    });
    return thisPromise;
  }

  samplePromiseRecursive ( positions:any[] = [], objectsToExclude:any[] = [], chunkSize:number = 10, resolve:any = null, progress:any = {} ) : any {

    let positionsProcess = positions.slice(progress.chunkIndex,progress.chunkIndex+chunkSize);
    let positionsLeftOver = positions.slice(progress.chunkIndex+chunkSize);

    // console.log ( '%c PROFILER %c SAMPLE_RECURSE', this.debugPrimary, Constants._red, positionsProcess.length, positionsLeftOver.length, progress );

    this.samplePositions ( positionsProcess, objectsToExclude ).then ( chunk => {

      progress.done++;
      this.percentFinished = progress.done * ( progress.factor * chunk.length );

      // console.log ( '%c PROFILER %c SAMPLE_RECURSE THEN', this.debugPrimary, Constants._red, this.percentFinished, progress, chunk );

      for ( let n=0; n<chunk.length; n++ ) {
        // let idx = p['__chunk_idx'] + n;
        positions[progress.chunkIndex+n] = chunk[n];
        let coord = Cesium.Cartesian3.fromRadians(chunk[n].longitude, chunk[n].latitude, chunk[n].height) ;
        this.entityHelper.addEntity( AnnotationType.volumepoint, { coord: coord }, 'volumepoint', 'volume_calc' );
        // console.log ( '%c PROFILER %c PROMISED CHUNK FLICK='+idx, this.debugPrimary, Constants._red, n, chunk[n] );
      }

      if ( positionsLeftOver.length && progress.done < progress.promises ) {

        setTimeout ( () => {

          // recursive loop the rest

          progress.chunkIndex = progress.chunkIndex + chunkSize;

          // console.log ( '%c PROFILER %c SAMPLE_RECURSE RECURSE_MORE', this.debugPrimary, Constants._red, positionsLeftOver.length );

          this.samplePromiseRecursive ( positions, objectsToExclude, chunkSize, resolve, progress );

        }, 30 );

        
      } else {

        // done, resolve

        // console.log ( '%c PROFILER %c SAMPLE_RECURSE DONE', this.debugPrimary, Constants._red, progress );

        resolve(positions);
      }

    });

  }
    
  samplePositions ( positions:any[] = [], objectsToExclude:any[] = [] ) {

    var samplePromise;

    const detailed:boolean = this.sampleResolution == 'high' ? true : false;
    
    // console.log ( '%c PROFILER %c PROMISING COORD', this.debugPrimary, Constants._red, positions, objectsToExclude );

    if ( this.sampleMethod == 'model' ) {

      if ( detailed ) {

        samplePromise = this.mapService.viewer.scene.sampleHeightMostDetailed(positions, objectsToExclude, 0.05);

      } else {
        
        samplePromise = new Promise ( resolve => { 
          let res = [];
          let idx = 0;

          positions.forEach ( pos => {
            let h = this.mapService.viewer.scene.sampleHeight(pos, objectsToExclude, 0.05);
            // console.log('##pos',pos,h);
            if ( h ) {
              pos['height'] = h;
            } else {

            }
            res.push(pos);
            idx++;
            // this.percentFinished = idx * factor;
          });
          resolve(res); 
        });
      }
    } else {
      if ( detailed ) {
        samplePromise = Cesium.sampleTerrainMostDetailed(this.mapService.viewer.terrainProvider, positions);
      } else {
        samplePromise = Cesium.sampleTerrain(this.mapService.viewer.terrainProvider, 11, positions);
      }
    }

    // samplePromise['__chunk_idx'] = chunkIdx;
    // console.log ( '%c PROFILER %c PROMISING POSITIONS', this.debugPrimary, Constants._red, samplePromise, this.sampleMethod, this.mapService.viewer.scene.sampleHeightSupported, positions.length );
    
    return samplePromise;
  }



  ngOnInit() {
    // because of local coordinates the sequence of loading scene is changed so once scene is ready we process
    if (this.mapService.scene) {
      // console.log ('@');
      this.init();
    } else {
      this.addSubscription( 'line-SceneChange',
        this.mapService.onSceneChange('line.component').subscribe(_ => {
          // console.log ('@@');
          this.init();
        })
      );
    }
  }

}
